export const OVERVIEW_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(3, minmax(200px, 1fr))',
    lg: 'repeat(4, minmax(200px, 1fr))'
  },
  gap: 2.5
};

export const DETAIL_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    lg: 'repeat(3, minmax(0, 1fr))'
  },
  gap: 2
};

export const PROJECT_STATUS_OPTIONS = [
  { value: 'planning', labelKey: 'DIRENCANAKAN / PERENCANAAN' },
  { value: 'in_progress', labelKey: 'SEDANG BERJALAN / BERLANGSUNG' },
  { value: 'on_hold', labelKey: 'DITAHAN / DIJEDA' },
  { value: 'cancelled', labelKey: 'DIBATALKAN / DIHENTIKAN' },
  { value: 'completed', labelKey: 'SELESAI / TUNTAS' },
  { value: 'retention', labelKey: 'RETENSI' },
  { value: 'closed', labelKey: 'DITUTUP / DIARSIPKAN' }
];

export const PROJECT_TAB_INDEX = {
  GENERAL: 0,
  SCHEDULE: 1,
  WORK_PLAN: 2,
  VALUE: 3,
  TEAM: 4,
  DOCUMENTS: 5,
  S_CURVE: 6,
  FIELD_PROGRESS: 7,
  IMPORT: 8
};
